export const ORDERS_SECTION_PERMISSIONS = ['patients_medical_history.read', 'prescribe.read'];

export const ORDERS_TABS = [
  { label: 'Orders', path: '', end: true, permission: 'patients_medical_history.read' },
  {
    label: 'Prescriptions',
    path: 'prescriptions',
    permission: 'prescribe.read',
    hideInViewport: true
  },
  { label: 'Referral requests', path: 'requests', permission: 'patients_medical_history.read' }
];
